import React from 'react'
import { CmsBlock } from 'lib/shared/__DEPRECATED__/CmsBlock'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Container } from './styled'

export const Community = () => {
  const blockId = CMS_BLOCK.HOME_COMMUNITY

  return (
    <Container>
      <CmsBlock
        id={blockId}
      >
        {({ isFailure, content }) => {
          if (isFailure) {
            return (
              <SampleData />
            )
          }
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: content
              }}
            />
          )
        }}
      </CmsBlock>
    </Container>
  )
}

const SampleData = () => {
  return (
    <div>
      <h2>livbrite is a community for people</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce varius rhoncus feugiat. Ut pellentesque dignissim erat, nec pharetra tellus fermentum sed. Cras eleifend ipsum nunc, id dignissim metus porta a. Pellentesque eget augue sollicitudin, elementum sapien id, lacinia libero. Suspendisse potenti. Curabitur eu porttitor arcu. Quisque at lorem lacinia, porta nisi at, vehicula lorem. Proin augue dui, iaculis vitae risus sit amet, varius elementum dolor. Donec dapibus, est in volutpat aliquam, dui tellus ultrices nunc, sit amet facilisis massa risus ut neque.</p>
    </div>
  )
}
